<template>
    <div class="horizontal grow">
		<div style="cursor: pointer; margin: 5px" @click="show(data, 'PREVIEW')" class="button-template" content="Preview" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
            <svg width="25" height="24" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 21C8.76222 21 2.33331 16.4416 2.33331 14C2.33331 11.5584 8.76222 7 14 7C19.2377 7 25.6666 11.5584 25.6666 14C25.6666 16.4416 19.2377 21 14 21ZM4.5801 14.5394C5.14008 15.1596 5.90952 15.8388 6.78201 16.4575C9.00613 18.0345 11.5209 18.9903 14 18.9903C16.4791 18.9903 18.9938 18.0345 21.218 16.4575C22.0904 15.8388 22.8599 15.1596 23.4199 14.5394C23.6006 14.3392 23.75 14.1551 23.8604 14C23.75 13.8449 23.6006 13.6608 23.4199 13.4606C22.8599 12.8404 22.0904 12.1612 21.218 11.5425C18.9938 9.9655 16.4791 9.00966 14 9.00966C11.5209 9.00966 9.00613 9.9655 6.78201 11.5425C5.90952 12.1612 5.14008 12.8404 4.5801 13.4606C4.3994 13.6608 4.24998 13.8449 4.13953 14C4.24998 14.1551 4.3994 14.3392 4.5801 14.5394ZM14 18.0833C11.7448 18.0833 9.91665 16.2552 9.91665 14C9.91665 11.7448 11.7448 9.91667 14 9.91667C16.2551 9.91667 18.0833 11.7448 18.0833 14C18.0833 16.2552 16.2551 18.0833 14 18.0833ZM14 15.9833C15.0953 15.9833 15.9833 15.0954 15.9833 14C15.9833 12.9046 15.0953 12.0167 14 12.0167C12.9046 12.0167 12.0166 12.9046 12.0166 14C12.0166 15.0954 12.9046 15.9833 14 15.9833Z" fill="#346F8B"/>
            </svg>
        </div>
        <!-- <div style="cursor: pointer; margin: 5px" @click="show(data, 'DELETE')" class="button-template" content="Delete" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.5 1.4C3.5 0.626801 4.1268 0 4.9 0H9.1C9.8732 0 10.5 0.626801 10.5 1.4V2.8H11.8928C11.8971 2.79996 11.9014 2.79996 11.9058 2.8H13.3C13.6866 2.8 14 3.1134 14 3.5C14 3.8866 13.6866 4.2 13.3 4.2H12.5518L11.9447 12.6997C11.8923 13.4324 11.2827 14 10.5482 14H3.45178C2.71729 14 2.10767 13.4324 2.05534 12.6997L1.44822 4.2H0.7C0.313401 4.2 0 3.8866 0 3.5C0 3.1134 0.313401 2.8 0.7 2.8H2.09422C2.09856 2.79996 2.1029 2.79996 2.10722 2.8H3.5V1.4ZM4.9 2.8H9.1V1.4H4.9V2.8ZM2.85178 4.2L3.45178 12.6H10.5482L11.1482 4.2H2.85178ZM5.6 5.6C5.9866 5.6 6.3 5.9134 6.3 6.3V10.5C6.3 10.8866 5.9866 11.2 5.6 11.2C5.2134 11.2 4.9 10.8866 4.9 10.5V6.3C4.9 5.9134 5.2134 5.6 5.6 5.6ZM8.4 5.6C8.7866 5.6 9.1 5.9134 9.1 6.3V10.5C9.1 10.8866 8.7866 11.2 8.4 11.2C8.0134 11.2 7.7 10.8866 7.7 10.5V6.3C7.7 5.9134 8.0134 5.6 8.4 5.6Z" fill="#346F8B"/>
            </svg>
        </div> -->
    </div>
</template>

<script>
export default {
    props: {
        show: {

        }
    },
    data() {
        return {
            data: {},
            hoverPreview: false,
            hoverDelete: false
        }
    }
}
</script>

<style scoped>

</style>

<style>
    .tippy-tooltip.customTheme-theme {
      background-color: #346F8B;
    }

    .tippy-popper[x-placement^='left'] .tippy-tooltip.customTheme-theme .tippy-arrow {
      border-left: 8px solid #346F8B;
    }
</style>


// WEBPACK FOOTER //
// src/components/Visits/Solutions/SolutionsTableButtons.vue